import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AlertHistoryMeta from './AlertHistoryMeta';
import { getAMLSCommonUnifiedAlertCounts } from '../../../redux/actions/common';

function mapStateToProps(state) {
  const { unifiedAlertCounts = {}, alertPartyIdentity = {} } = state.amlsCommon;
  const { data: alertCounts, isLoading } = unifiedAlertCounts;
  const { data: customerInfo, isLoading: customerLoading } = alertPartyIdentity;
  const { partyKey = '' } = customerInfo || {};

  return {
    alertCounts,
    isLoading: isLoading || customerLoading,
    customerId: partyKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonUnifiedAlertCounts
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertHistoryMeta);
